import { initializeApp, getApps, getApp } from "firebase/app";
import { getDatabase } from "firebase/database";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  databaseURL: process.env.REACT_APP_FIREBASE_DATABASE_URL,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
};

const canInit =
  Boolean(firebaseConfig.apiKey) &&
  Boolean(firebaseConfig.databaseURL) &&
  Boolean(firebaseConfig.projectId);

/** @type {import("firebase/app").FirebaseApp | null} */
let app = null;
/** @type {import("firebase/database").Database | null} */
let db = null;
/** @type {import("firebase/auth").Auth | null} */
let auth = null;

if (canInit) {
  try {
    app = getApps().length === 0 ? initializeApp(firebaseConfig) : getApp();
    db = getDatabase(app);
    auth = getAuth(app);
  } catch (err) {
    console.error("[GifteKart] Firebase init failed:", err);
  }
} else if (process.env.NODE_ENV === "development") {
  console.warn(
    "[GifteKart] Firebase env incomplete. Add REACT_APP_FIREBASE_* to `.env` (see `.env.example`). The UI will load but data features stay disabled."
  );
}

export { app, db, auth };
